module.exports = __webpack_public_path__ + "media/KikiAJ.5a32bf44.mp3";